const getAccountSlug = () => {
  return window.location.pathname.match(/(pimwacorp)/g)?.[0];
};

export default getAccountSlug;
